import {
    useEffect,
    type FC
} from "react";
import type {
    IItemDescriptionProps,
    ItemPartContentProps
} from "../../type";
import {
    ROW_CARD_SUBTITLE_SKELETON_WIDTH
} from "../../../rowCard/stylesheet";
import {
    getCardChildrenText,
    getCardHiddenProps
} from "../../../card/util";
import {
    withItemContext
} from "../../context";
import Skeleton from "../../../skeleton";
import Text from "../../../text";

const ItemDescriptionBase: FC<ItemPartContentProps<IItemDescriptionProps>> = ({
    customTheme: customThemeProp,
    numberOfLines = 2,
    children,
    context,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        registerPart,
        isLoading
    } = context;

    const text = getCardChildrenText(children);

    const hiddenProps = getCardHiddenProps({
        isPressable: context.isPressable,
        text
    });

    useEffect(() => {
        if(isLoading) {
            return;
        }

        return registerPart("description", text);
    }, [
        registerPart,
        isLoading,
        text
    ]);

    if(isLoading) {
        return <Skeleton
            width={ROW_CARD_SUBTITLE_SKELETON_WIDTH}
            typography={context.descriptionVariant}
            customTheme={customTheme}
            variant="text"
        />;
    }

    return <Text
        {...hiddenProps}
        {...props}
        customColor={context.descriptionColor}
        variant={context.descriptionVariant}
        numberOfLines={numberOfLines}
        id={context.descriptionID}
        customTheme={customTheme}
    >
        {children}
    </Text>;
};
export default withItemContext("description", ItemDescriptionBase);
